module.exports = __webpack_public_path__ + "static/media/headshot3.32b7eaa7.jpg";